import { Box, Button, CircularProgress, Paper, Typography, useTheme } from '@mui/material'
import CreateDiscussionDialog from '../../components/discussion-forum/CreateDiscussionDialog'
import DiscussionCard from '../../components/discussion-forum/DiscussionCard'
import DataLoadingSpinner from '../../components/common/DataLoadingSpinner'
import { useDiscussionForum } from '../../store/discussionforum.store'
import CustomSearchBar from '../../components/common/CustomSearchBar'
import noDiscussionsImg from '../../assets/no-discussions.svg'
import { useUserStore } from '../../store/user.store'
import React, { useCallback, useEffect, useState } from 'react'
import { Icons } from '../../utils/utilities'
import { Link, Outlet, useNavigate, useParams } from 'react-router-dom'
import { observer } from 'mobx-react'
import api from '../../service/api'
import { toast } from 'react-toastify'
import BreadcrumbList from '../../components/common/BreadcrumbList'

const MyDiscussions = observer( () => {

    const [retrievingLegacyData, setRetrievingLegacyData] = useState( false )
    const [createDialogStatus, setCreateDialogStatus] = useState( false )
    const [searchText, setSearchText] = useState( "" )
    const [loading, setLoading] = useState( true )

    const DiscussionForumStore = useDiscussionForum()
    const UserStore = useUserStore()
    const { id } = useParams()

    const { palette } = useTheme()

    const navigate = useNavigate()

    // const navigateToDiscussionsWithQuery = ( query ) => {
    //     const usertype = UserStore.getUser.user_role === "STUDENT" ? 'student' : "faculty"
    //     navigate( `/${usertype}/discussions?${query || ""}` )
    // }


    const retrieveOldDiscussions = async () => {
        try {
            setRetrievingLegacyData( true )
            await api.discussionForum.retrieveLegacyAliveDiscussions()
            await UserStore.fetchUser()
            await getData()
        } catch ( err ) {
            toast( err?.response?.data?.message || "Something went wrong while retriving old discussions!" )
        } finally {
            setRetrievingLegacyData( false )
        }
    }

    const getData = useCallback( async () => {
        setLoading( true )
        await DiscussionForumStore.fetchUserDiscussions()
        const searchParams = window.location.search
        if ( DiscussionForumStore?.getDiscussions.length > 0 && !id ) {
            navigate( `${DiscussionForumStore?.getDiscussions[0]?._id}${searchParams}` )
        }
        setLoading( false )
    }, [DiscussionForumStore, id, navigate] )

    useEffect( () => {
        getData()
    }, [getData] )

    return (
        <Box minWidth="0" overflow="auto" flexGrow={1} padding="20px">
            {/* <Typography marginBottom="10px" fontSize="14px" fontWeight={500} display="flex" alignItems="center" color="textSecondary">
                <Link className="breadcrumb-link" to={UserStore.getUser.user_role === "STUDENT" ? "/student/discussions" : "/faculty/discussions"}>Discussions</Link>
                {Icons.small.ChevronRightIcon} My discussions
            </Typography> */}
            <BreadcrumbList items={[
                { link: UserStore.getUser.user_role === "STUDENT" ? "/student/discussions" : "/faculty/discussions", label: "Discussions" },
                "My discussions"
            ]} />

            <Box sx={{ flexGrow: ( !loading && DiscussionForumStore.getDiscussions.length > 0 ) ? 1 : "initial", minHeight: !loading && "350px", display: "flex", flexDirection: "column", overflow: "hidden" }}>
                <CreateDiscussionDialog getData={getData} state={createDialogStatus} setState={setCreateDialogStatus} />

                <Box
                    display="flex"
                    position="relative"
                    alignItems="center"
                    justifyContent="space-between">
                    <Box position="relative" sx={{ zIndex: 10 }} >
                        <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">My Discussions</Typography>
                        <Typography variant="subtitle2" fontSize="12px" color='textSecondary'>Manage your discussion from one place...</Typography>

                    </Box>
                    {<Button onClick={() => setCreateDialogStatus( true )} variant="contained" disableElevation startIcon={Icons.default.AddIcon} sx={{ textTransform: "capitalize" }}>Create</Button>}
                </Box>
                {!loading && <Box flexGrow={1} display="flex" flexDirection="column">

                    {/* Discussions */}
                    {DiscussionForumStore.getDiscussions.length !== 0 && <Box padding="10px 20px">
                        <CustomSearchBar border="1px solid #d3d3d3" value={searchText} onChange={( e ) => setSearchText( e.target.value )} style={{ width: "100%" }} placeholder='Search from you discussion by title' />
                    </Box>}
                    {DiscussionForumStore.getDiscussions.length > 0 && <Box minHeight="300px" flexGrow={1} height="600px" alignItems="flex-start" display="grid" overflow="auto" gridTemplateColumns={{ md: "350px auto", xs: "1fr" }} gap="20px" padding="20px">
                        <Box display="flex" className="slim-custom-scrollbar" flexDirection="column" height="100%" overflow="auto" gap="10px" >
                            {DiscussionForumStore.getDiscussions
                                .filter( i => i.title?.toLowerCase()?.includes( searchText?.toLowerCase() ) )
                                .map( discussion => (
                                    <DiscussionCard discussion={discussion} key={discussion._id} />
                                ) )}
                        </Box>
                        <Box height="100%" display={{ md: "flex", xs: "none" }} flexDirection="column" overflow="auto">
                            <Outlet />
                        </Box>
                    </Box>}

                    {/* No discussions secction */}
                    {DiscussionForumStore.getDiscussions
                        .filter( i => i.title?.toLowerCase()?.includes( searchText?.toLowerCase() ) )
                        .length === 0 &&
                        <Box padding="20px" marginTop="10px" borderRadius="10px" bgcolor={palette.contentBg} display="flex" alignItems="center" justifyContent="center" flexDirection="column" gap="10px">
                            <img width="150px" src={noDiscussionsImg} alt="No discussions" />
                            <Typography variant='subtitle2' color="textSecondary">You haven't created any discussions!</Typography>
                            {DiscussionForumStore.getDiscussions.length === 0 ?
                                <Button onClick={() => setCreateDialogStatus( true )} color="secondary" sx={{ width: "fit-content", textTransform: "capitalize", flexGrow: 1 }} variant="outlined" startIcon={Icons.default.AddIcon}>Create one</Button> :
                                <Button onClick={() => setSearchText( "" )} sx={{ width: "fit-content", textTransform: "capitalize", flexGrow: 1 }} variant="outlined" color="error" startIcon={Icons.default.FilterAltOff}>Remove search filter</Button>
                            }
                        </Box>}
                </Box>}
                {loading && <DataLoadingSpinner waitingMessage="Loading your discussions..." />}
            </Box>
        </Box>
    )
} )

export default MyDiscussions
